export default __webpack_public_path__ + "static/media/logo.3e1c5f01.svg";